<template>
  <div id="main_page">
    <TopNavigation :showIndexBtn="isShowIndexBtn" :showMapBtn="isShowMapBtn" :showDataBtn="isShowDataBtn"
      :currentLanguage="currentLanguage" @back-to-index="onBackToIndex" @back-to-map="onBackToMap" @open-data-page="onOpenDataPage" />
    <InfoPage :isVisible="isShowData" :currentWayspotData="currentWayspotData" @close="closeInfoPage" />
    <div class="container">
      <!-- <img src="@/assets/images/qa_title.png" alt="" class="title-image"></img> -->
      <div class="title-box">
        <img src="@/assets/images/icon_QA.png" alt="" class="icon-QA">{{ languageTexts.topicText[currentLanguage] }}
      </div>
      <!-- 問答區域 -->
      <transition name="slide-fade" mode="out-in">
        <div v-if="!showCorrectAnswer" class="content-box" key="question">
          <div style="width: 90%;margin: 1rem auto;position: relative;">
            <p :class="(currentLanguage == 'en') ? 'en' : ''" class="question-text">
              {{ languageTexts[choosenWayspotTitle][currentLanguage].topic }}
            </p>
            <transition-group name="option-bounce" tag="div">
              <div v-for="option in ['A', 'B']" :key="option" class="image-options" :class="{
                'disabled': disabledOptions.includes(option),
                'option-hover': !disabledOptions.includes(option)
              }" @click="!disabledOptions.includes(option) && answer(option)">
                <div class="image-option-left">{{ option }}</div>
                <div class="image-option-right">
                  <img :src="getImagePath(languageTexts[choosenWayspotTitle][currentLanguage]['image' + option])"
                    alt="">
                  <transition name="fade">
                    <div v-if="disabledOptions.includes(option)" class="disabled-overlay">❌</div>
                  </transition>
                </div>
              </div>
            </transition-group>
          </div>
        </div>

        <!-- 正確答案區域 -->
        <div v-else class="correct-box" key="answer">
          <div style="width: 90%;margin: 1rem auto;position: relative;">
            <div class="top success-header">
              <img src="@/assets/images/icon_check.png" alt="" style="width: 10%;" class="check-icon">
              <span>{{ languageTexts.answerText[currentLanguage].correct }}</span>
            </div>
            <p :class="(currentLanguage == 'en') ? 'en' : ''" class="success-text">
              {{ languageTexts[choosenWayspotTitle][currentLanguage].answerTrueText }}
            </p>
            <div class="model-place" ref="modelContainer">
              <transition name="fade">
                <div v-if="isModelLoading" class="model-loading">
                  <div class="loading-spinner"></div>
                  <span>{{ languageTexts.answerText[currentLanguage].modelLoading }}</span>
                </div>
              </transition>
              <!-- 手指圖標提示 -->
              <transition name="fade">
                <div v-if="showFingerIcon" class="finger-icon-hint" @click="hideFingerIcon">
                  <img src="@/assets/images/finger-icon.gif" alt="Touch to interact">
                </div>
              </transition>
            </div>
            <div :class="(currentLanguage == 'en') ? 'bottom_en' : ''" class="footer-text">
              <div class="imgdiv"><img src="@/assets/images/icon_star.png" alt="" class="icon-footer"></div>
              <div v-html="languageTexts.answerText[currentLanguage].footerText"></div>
            </div>
          </div>

        </div>
      </transition>

    </div>

    <!-- 錯誤答案 Lightbox -->
    <div v-if="showErrorLightbox" class="error-lightbox-overlay" @click="closeErrorLightbox">
      <div class="error-lightbox" @click.stop>
        <div class="error-lightbox-content">
          <p :class="(currentLanguage == 'en') ? 'en' : ''" style="text-align: left;">{{ errorMessage }}</p>
        </div>
        <div class="error-lightbox-footer">
          <button class="confirm-btn" @click="closeErrorLightbox">{{
            languageTexts.answerText[currentLanguage].buttonConfirm }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { getBasePath } from '@/utils/urlBase'
import TopNavigation from '@/components/TopNavigation.vue'
import InfoPage from '@/components/InfoPage.vue'
import { wayspotDataManager, pointKeyMap } from '@/utils/wayspotDataManager.js'

// Three.js imports
import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

export default {
  name: 'QA',
  components: {
    TopNavigation,
    InfoPage
  },
  data() {
    return {
      isShowIndexBtn: true,
      isShowMapBtn: true,
      isShowDataBtn: true,
      isShowData: false,
      indexLink: window.location.protocol + '//' + window.location.host + getBasePath(),
      // 3D 模型相關（Three.js 物件不放 data，避免 Vue Proxy 包裹導致崩潰）
      isModelLoading: false,
      // 錯誤答案 lightbox 相關
      showErrorLightbox: false,
      errorMessage: '',
      disabledOptions: [], // 存儲被禁用的選項
      // 顯示狀態控制
      showCorrectAnswer: false, // 控制是否顯示正確答案區域
      showFingerIcon: false, // 控制手指圖標顯示
      languageTexts: {
        topicText: {
          zh: '植物小百科',
          en: 'Plant Encyclopedia'
        },
        'answerText': {
          zh: {
            correct: '答對了！',
            incorrect: '答錯了！',
            modelLoading: '載入 3D 模型中...',
            buttonConfirm: '確定',
            footerText: '點選<span style="color:black">返回地圖</span>按鈕 體驗其他內容'
          },
          en: {
            correct: 'Correct!',
            incorrect: 'Try again!',
            modelLoading: 'Loading 3D model...',
            buttonConfirm: 'Confirm',
            footerText: 'Tap <span style="color:black">\'Back to Map\'</span> to explore more.'
          }
        },

        '科碼門口': {
          zh: {
            imageA: 'QA_BambusaA.jpg',
            imageB: 'QA_BambusaB.jpg',
            topic: '請問，下列哪一個圖片是「刺竹筍」？',
            answerTrue: 'B',
            answerTrueText: '答對了，這個就是刺竹筍唷，卑南族人常常將刺竹筍做成美味的菜餚。',
            answerFalseText: '不對唷，這是帶殼的筊白筍，你要不要再思考一下呢？',
            modelPath: 'QA3D_4_SpinyBamboo.glb',
          },
          en: {
            imageA: 'QA_BambusaA.jpg',
            imageB: 'QA_BambusaB.jpg',
            topic: 'Which option shows the Thorny Bamboo Shoot (Bambusa stenostachya)?',
            answerTrue: 'B',
            answerTrueText: 'That\'s right, this is the Thorny Bamboo Shoot. The Puyuma people often make delicious dishes with Thorny Bamboo Shoots.',
            answerFalseText: 'Incorrect! This is a water bamboo shoot (Zizania latifolia) with its husk. Would you like to think again?',
            modelPath: 'QA3D_4_SpinyBamboo.glb',
          },
        },
        'Mango': {
          zh: {
            imageA: 'QA_mangoA.jpg',
            imageB: 'QA_mangoB.jpg',
            topic: '請問，下列哪一個圖片是「土芒果的果實」？',
            answerTrue: 'A',
            answerTrueText: '答對了，這是土芒果果實！',
            answerFalseText: '這是果實外形貌似芒果的海檬果，整株植物都是有毒的，要小心唷！',
            modelPath: 'QA3D_2_Mango.glb',
          },
          en: {
            imageA: 'QA_mangoA.jpg',
            imageB: 'QA_mangoB.jpg',
            topic: 'Which of the following pictures shows the fruit of the local mango?',
            answerTrue: 'A',
            answerTrueText: 'Correct! This is the fruit of the local mango!',
            answerFalseText: 'This is Cerbera manghas, a sea mango that only looks like a mango. The entire plant is poisonous—be careful!',
            modelPath: 'QA3D_2_Mango.glb',
          },
        },
        'Chinaberry': {
          zh: {
            imageA: 'QA_chinaberryA.JPG',
            imageB: 'QA_chinaberryB.JPG',
            topic: '請問，下列哪一個圖片是「苦楝的花」？',
            answerTrue: 'B',
            answerTrueText: '答對了，苦楝開出的是淡紫色小花。',
            answerFalseText: '唉呀，這是臺灣欒樹開出的黃色小花唷。',
            modelPath: 'QA3D_5_Chinaberry.glb',
          },
          en: {
            imageA: 'QA_chinaberryA.JPG',
            imageB: 'QA_chinaberryB.JPG',
            topic: 'Which of the following pictures shows the flower of the chinaberry tree?',
            answerTrue: 'B',
            answerTrueText: 'Correct! Chinaberry trees bloom with small, pale purple flowers.',
            answerFalseText: 'Oops! That’s the yellow blossom of the Taiwan Golden train tree.',
            modelPath: 'QA3D_5_Chinaberry.glb',
          },
        },
        'VitexNigra': {
          zh: {
            imageA: 'QA_vitexA.JPG',
            imageB: 'QA_vitexB.JPG',
            topic: '請問，下列哪一個圖片是「黃荊的花」？',
            answerTrue: 'A',
            answerTrueText: '答對了，黃荊所開出的淡紫色小花，如果你湊近去聞會有個特殊的香氣喔。',
            answerFalseText: '這是厚葉石斑木的花，有5片花瓣，花期大概在每年4到5月。',
            modelPath: 'NegundoChastetree.glb',
          },
          en: {
            imageA: 'QA_vitexA.JPG',
            imageB: 'QA_vitexB.JPG',
            topic: 'Which of the following pictures shows the flower of Negundo Chaste tree?',
            answerTrue: 'A',
            answerTrueText: 'Correct! Negundo Chaste tree blooms with small, pale purple flowers—and if you lean in close, you’ll notice they have a distinctive fragrance.',
            answerFalseText: 'This is the flower of Indian Hawthorn. It has five petals and typically blooms from April to May each year.',
            modelPath: 'NegundoChastetree.glb',
          },
        },
        'SpinyBamboo': {
          zh: {
            imageA: 'QA_BambusaA.jpg',
            imageB: 'QA_BambusaB.jpg',
            topic: '請問，下列哪一個圖片是「刺竹筍」？',
            answerTrue: 'B',
            answerTrueText: '答對了，這個就是刺竹筍唷，卑南族人常常將刺竹筍做成美味的菜餚。',
            answerFalseText: '不對唷，這是帶殼的筊白筍，你要不要再思考一下呢？',
            modelPath: 'QA3D_4_SpinyBamboo.glb',
          },
          en: {
            imageA: 'QA_BambusaA.jpg',
            imageB: 'QA_BambusaB.jpg',
            topic: 'Which of the following pictures shows the shoot of thorny bamboo?',
            answerTrue: 'B',
            answerTrueText: 'Correct! This is the thorny bamboo shoot—Pinuyumayan families often use it to make delicious dishes.',
            answerFalseText: 'Not quite! That’s a water bamboo shoot with its husk. Want to try again?',
            modelPath: 'QA3D_4_SpinyBamboo.glb',
          },
        },
        'Areca': {
          zh: {
            imageA: 'QA_betelA.jpg',
            imageB: 'QA_betelB.jpg',
            topic: '請問，下列哪一個圖片是「檳榔的葉鞘」？',
            answerTrue: 'A',
            answerTrueText: '沒錯，這就是檳榔葉鞘唷，常被製作成容器盛裝食物。',
            answerFalseText: '不對唷，這是月桃葉鞘，也是常見的部落植物。',
            modelPath: 'QA3D_6_Areca.glb',
          },
          en: {
            imageA: 'QA_betelA.jpg',
            imageB: 'QA_betelB.jpg',
            topic: 'Which of the following pictures shows the leaf sheath of the areca nut palm?',
            answerTrue: 'A',
            answerTrueText: 'Exactly! This is the Betel Nut Palm leaf sheath, often fashioned into containers for holding food.',
            answerFalseText: 'Nope—this is the leaf sheath of Alpinia zerumbet (shell ginger), another common plant in Indigenous communities.',
            modelPath: 'QA3D_6_Areca.glb',
          },
        },
        'PaperMulberry': {
          zh: {
            imageA: 'QA_mulberryA.JPG',
            imageB: 'QA_mulberryB.JPG',
            topic: '請問，下列哪一個圖片是「構樹雌株的果實」？',
            answerTrue: 'A',
            answerTrueText: '答對了！這是構樹的果實，是不是很漂亮啊。',
            answerFalseText: '不對唷，這是構樹雄株花穗。',
            modelPath: 'QA3D_3_PaperMulberry.glb',
          },
          en: {
            imageA: 'QA_mulberryA.JPG',
            imageB: 'QA_mulberryB.JPG',
            topic: 'Which of the following pictures shows the female fruit of the paper mulberry?',
            answerTrue: 'A',
            answerTrueText: 'Correct! This is the fruit of the paper mulberry—isn’t it beautiful?',
            answerFalseText: 'Not quite.That’s the male flower catkin of the paper mulberry.',
            modelPath: 'QA3D_3_PaperMulberry.glb',
          },
        },
        'Soapberry': {
          zh: {
            imageA: 'QA_sapindusA.JPG',
            imageB: 'QA_sapindusB.JPG',
            topic: '請問，下列哪一個圖片是「無患子的果實」？',
            answerTrue: 'B',
            answerTrueText: '答對了，這是無患子的果實，你有沒有用過無患子製成的清潔用品呢。',
            answerFalseText: '哎呀，這個是止宮樹的果實，他的顏色相對無患子果實來說要鮮豔的多。',
            modelPath: 'Soapberry.glb',
          },
          en: {
            imageA: 'QA_sapindusA.JPG',
            imageB: 'QA_sapindusB.JPG',
            topic: 'Which of the following pictures shows the fruit of the soapberry?',
            answerTrue: 'B',
            answerTrueText: 'Correct! This is the soapberry fruit! Have you ever used soapberry-based cleaning products?',
            answerFalseText: 'Oops—that’s the fruit of Timor allophylus. Its color is much brighter than that of the soapberry.',
            modelPath: 'Soapberry.glb',
          },
        },
        'TaiwanFlamegold': {
          zh: {
            imageA: 'QA_taiwanTreeA.JPG',
            imageB: 'QA_taiwanTreeB.JPG',
            topic: '請問，下列哪一個圖片是「臺灣欒樹的果實」？',
            answerTrue: 'A',
            answerTrueText: '答對了！這就是臺灣欒樹的果實，是不是漂亮的像朵花呢。',
            answerFalseText: '不對唷，這是瓊崖海棠的果實，臺灣欒樹果實不是長這樣唷。',
            modelPath: 'TaiwaneseGoldenRainTree.glb',
          },
          en: {
            imageA: 'QA_taiwanTreeA.JPG',
            imageB: 'QA_taiwanTreeB.JPG',
            topic: 'Which of the following pictures shows the fruit of the Taiwan Golden Rain Tree?',
            answerTrue: 'A',
            answerTrueText: 'Correct! This is the golden rain tree’s fruit—doesn\’t it look almost like a flower?',
            answerFalseText: 'Nope—that’s the fruit of Beauty Leaf. The golden rain tree’s fruit doesn’t look like that.',
            modelPath: 'TaiwaneseGoldenRainTree.glb',
          },
        },
        'Taiwancrapemyrtle': {
          zh: {
            imageA: 'QA_nineA.JPG',
            imageB: 'QA_nineB.JPG',
            topic: '請問，下列哪一個圖片是「九芎的樹幹」？',
            answerTrue: 'B',
            answerTrueText: '答對了！九芎的樹幹非常光滑，可是有著別名「猴不爬」呢！',
            answerFalseText: '唉呀，這是苦楝的樹幹，你有看到他的表皮看起來是比較粗糙的嗎？',
            modelPath: 'TaiwanCrepeMyrtle.glb',
          },
          en: {
            imageA: 'QA_nineA.JPG',
            imageB: 'QA_nineB.JPG',
            topic: 'Which of the following pictures shows the trunk of the Subcostate Crepe Myrtle?',
            answerTrue: 'B',
            answerTrueText: 'Correct! The trunk of the Subcostate Crepe Myrtle is very smooth—that’s why it’s nicknamed the “monkey won’t climb”!',
            answerFalseText: 'Oops! That’s the trunk of a chinaberry tree. Notice how its bark is much rougher?',
            modelPath: 'TaiwanCrepeMyrtle.glb',
          },
        },
        'LargeLeavedNanmu': {
          zh: {
            imageA: 'QA_bigA.JPG',
            imageB: 'QA_bigB.JPG',
            topic: '請問，下列哪一個圖片是「大葉楠的新芽」？',
            answerTrue: 'B',
            answerTrueText: '答對了！大葉楠的新芽看起來像紅色蠟燭一樣，很漂亮吧！',
            answerFalseText: '這是雀榕的新芽，給你個提示，大葉楠的新芽紅紅的唷。',
            modelPath: 'LargeLeavedNanmu.glb',
          },
          en: {
            imageA: 'QA_bigA.JPG',
            imageB: 'QA_bigB.JPG',
            topic: 'Which of the following pictures shows the new bud of the large-leaved Machilus?',
            answerTrue: 'B',
            answerTrueText: 'Correct! The new buds of this tree look like little red candles—aren’t they beautiful?',
            answerFalseText: 'Not quite. That’s the new bud of a Red Fruit Fig-tree. Here’s a hint: Machilus buds are reddish in color.',
            modelPath: 'LargeLeavedNanmu.glb',
          },
        },
        'Parasolleaftree': {
          zh: {
            imageA: 'QA_bloodA.JPG',
            imageB: 'QA_bloodB.JPG',
            topic: '請問，下列哪一個圖片是「血桐的葉子」？',
            answerTrue: 'A',
            answerTrueText: '正確答案！血桐是盾狀葉，葉柄長在靠近葉子中間的地方。',
            answerFalseText: '唉呀，這是蟲屎的葉子，不是血桐葉。',
            modelPath: 'ParasolLeafTree.glb',
          },
          en: {
            imageA: 'QA_bloodA.JPG',
            imageB: 'QA_bloodB.JPG',
            topic: 'Which of the following pictures shows the leaf of the Elephant’s ear?',
            answerTrue: 'A',
            answerTrueText: 'Correct answer! The Shield-leaf Tree has a peltate leaf shape. The stem is attached near the middle of the leaf.',
            answerFalseText: 'Oops! That’s the leaf of Molucca Mallotus, not the Elephant’s ear.',
            modelPath: 'ParasolLeafTree.glb',
          },
        },
        'Barringtoniaasiatica': {
          zh: {
            imageA: 'QA_chessA.jpg',
            imageB: 'QA_chessB.JPG',
            topic: '請問，下列哪一個圖片是「棋盤腳的花」？',
            answerTrue: 'A',
            answerTrueText: '答對了！棋盤腳的花是不是就像夏夜裡的煙火，耀眼動人。',
            answerFalseText: '咦？棋盤腳的花應該是有上百根細細長長的雄蕊才對唷。',
            modelPath: 'FishPoisonTreeFlower.glb',
          },
          en: {
            imageA: 'QA_chessA.jpg',
            imageB: 'QA_chessB.JPG',
            topic: 'Which of the following pictures shows the flower of the Fish Poison Tree?',
            answerTrue: 'A',
            answerTrueText: 'Correct! The flower of the Fish Poison Tree really does look like summer fireworks—bright and dazzling in the night!',
            answerFalseText: 'Oops! That one is a Taiwan Hibiscus. The Fish Poison Tree flower has hundreds of long, thin stamens.',
            modelPath: 'FishPoisonTreeFlower.glb',
          },
        },
      },
    }
  },
  computed: {
    currentLanguage() {
      return Cookies.get('lang') || 'zh'
    },
    choosenWayspotTitle() {
      console.log('choosenWayspotTitle:', this.$route.query.point)
      return this.$route.query.point || '科碼門口'
    },
    currentWayspotData() {
      const point = this.$route.query.point
      const dbKey = pointKeyMap[point]
      if (!dbKey) return null
      return wayspotDataManager.getWayspotData(dbKey, this.currentLanguage)
    },
  },
  methods: {
    onOpenDataPage() {
      this.isShowData = true
      document.getElementById('btn_data').style.backgroundColor = '#fdd089';
    },
    closeInfoPage() {
      this.isShowData = false
      const btnData = document.getElementById('btn_data');
      if (btnData) {
        btnData.style.backgroundColor = 'rgba(153, 153, 153, 0.7)';
      }
    },
    // TopNavigation 組件需要的方法
    onBackToIndex() {
      window.location.href = this.indexLink
    },

    onBackToMap() {
      this.$router.push({ name: 'Map' })
    },

    // 處理答案選擇
    answer(selectedOption) {
      const currentQuestions = this.languageTexts[this.choosenWayspotTitle][this.currentLanguage]
      const correctAnswer = currentQuestions.answerTrue

      if (selectedOption === correctAnswer) {
        // 答對了，切換到正確答案畫面
        this.showCorrectAnswer = true

        // 顯示載入狀態
        this.isModelLoading = true

        // 延遲初始化 3D 場景，確保 DOM 已渲染
        setTimeout(() => {
          this.init3DSceneDirectly()
        }, 500) // 增加延遲時間，等待動畫完成

      } else {
        // 答錯了，顯示錯誤 lightbox
        this.errorMessage = currentQuestions.answerFalseText
        this.showErrorLightbox = true

        // 將錯誤的選項加入禁用列表
        if (!this.disabledOptions.includes(selectedOption)) {
          this.disabledOptions.push(selectedOption)
        }
      }
    },

    // 關閉錯誤 lightbox
    closeErrorLightbox() {
      this.showErrorLightbox = false
      this.errorMessage = ''
    },

    // 重置遊戲狀態（當切換植物或重新開始時）
    resetGameState() {
      this.disabledOptions = []
      this.showErrorLightbox = false
      this.errorMessage = ''
      this.isModelLoading = false
      this.showCorrectAnswer = false // 重置為顯示問題區域
      this.showFingerIcon = false // 重置手指圖標狀態
    },
    
    // 隱藏手指圖標
    hideFingerIcon() {
      this.showFingerIcon = false;
    },

    // 獲取圖片路徑
    getImagePath(imageName) {
      return `./assets/images/${imageName}`
    },

    // 直接初始化 3D 場景
    init3DSceneDirectly() {
      const container = this.$refs.modelContainer
      if (!container) return

      const { modelPath } = this.languageTexts[this.choosenWayspotTitle][this.currentLanguage]
      const MODEL_PATH = `./assets/models/${modelPath}`

      const w = container.clientWidth
      const h = container.clientHeight

      this._scene = new THREE.Scene()
      this._scene.background = new THREE.Color(0xdddddd)

      this._camera = new THREE.PerspectiveCamera(75, w / h, 0.1, 1000)
      this._camera.position.set(0, 0, 3)

      this._renderer = new THREE.WebGLRenderer({ antialias: true })
      this._renderer.setSize(w, h)
      container.appendChild(this._renderer.domElement)

      const ambientLight = new THREE.AmbientLight(0xffffff, 1)
      this._scene.add(ambientLight)
      const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5)
      directionalLight.position.set(5, 5, 5).normalize()
      this._scene.add(directionalLight)

      const MODEL_SCALE = {
        PaperMulberry: 0.03,
        Chinaberry: 0.04,
      }
      const modelScale = MODEL_SCALE[this.choosenWayspotTitle] ?? 2

      new GLTFLoader().load(
        MODEL_PATH,
        (gltf) => {
          this._model = gltf.scene
          this._scene.add(this._model)
          this._model.scale.set(modelScale, modelScale, modelScale)
          this._model.position.y = -0.5
          this.isModelLoading = false
          setTimeout(() => { this.showFingerIcon = true }, 300)
        },
        undefined,
        (error) => { console.error('GLB 載入失敗:', error) }
      )

      this._controls = new OrbitControls(this._camera, this._renderer.domElement)
      this._controls.enableDamping = true
      this._controls.dampingFactor = 0.05
      this._controls.screenSpacePanning = false
      this._controls.minDistance = 0.5
      this._controls.maxDistance = 10
      this._controls.addEventListener('start', () => { this.hideFingerIcon() })

      this._resizeHandler = () => {
        const cw = container.clientWidth
        const ch = container.clientHeight
        this._camera.aspect = cw / ch
        this._camera.updateProjectionMatrix()
        this._renderer.setSize(cw, ch)
      }
      window.addEventListener('resize', this._resizeHandler, false)

      const animate = () => {
        requestAnimationFrame(animate)
        this._controls.update()
        this._renderer.render(this._scene, this._camera)
      }
      animate()
    },

  },
  mounted() {
    this.resetGameState()
  },

  beforeUnmount() {
    if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler)
    if (this._controls) this._controls.dispose()
    if (this._renderer) {
      this._renderer.dispose()
      this._renderer.domElement.remove()
    }
  },
}
</script>
<style scoped>
.topnav {
  position: relative !important;
}

.container {
  width: 80%;
  margin: auto;
}

.container .title-image {
  width: 95%;
}

.container .title-box {
  width: 100%;
  background-color: rgba(67, 106, 178, 0.8);
  margin: 1rem 0;
  border-radius: 20px;
  color: white;
  font-size: 1.7rem;
  letter-spacing: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
}

.container .title-box .icon-QA {
  width: 10%;
  margin: 1rem 0rem;
}

.container .content-box {
  text-align: center;
  width: 100%;
  color: #333;
  margin-top: 2svh;
  border-radius: 25px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  position: relative;
  overflow: hidden;
  height: 65svh;
  background-image: url(@/assets/images/answer_box.png);
  background-size: 120%;
  background-position: center;
  box-shadow: inset 0 0 600px 0px rgba(255, 255, 255, 0.5);
  overflow: scroll;
}

.container .content-box p,
.container .correct-box p {
  font-size: 1.3rem;
  letter-spacing: 3px;
  text-align: left;
  color: #333;
}

.footer-text {
  display: flex;
  font-size: 1rem;
  color: #333;
  align-items: center;
  justify-content: center;
  padding-bottom: 10px;
}

.footer-text .imgdiv {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 2%;
}

.footer-text img {
  width: 1.1rem;
}

.en {
  letter-spacing: 0px !important;
}

.bottom_en {
  letter-spacing: 0px !important;
  justify-content: flex-start !important;
}

.container .boxImage {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: -1;
  opacity: 0.6;
  object-fit: cover;
  /* 防止圖片隨內容滾動的額外設定 */
  background-attachment: fixed;
}


.container .content-box .image-options {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 1rem 0;
}

.container .content-box .image-options .image-option-left {
  color: white;
  font-size: 1.7rem;
  background: rgba(67, 106, 178, 0.9);
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container .content-box .image-options .image-option-right {
  width: 70%;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid #888;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.container .content-box .image-options .image-option-right img {
  max-width: 100%;
  max-height: 100%;
}

.container .correct-box {
  text-align: center;
  width: 100%;
  color: black;
  margin-top: 2svh;
  border-radius: 25px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  position: relative;
  overflow: hidden;
  height: 65svh;
  background-color: rgba(255, 255, 255, 0.1);
  overflow: scroll;
  box-shadow: inset 0 0 50px 5px rgba(255, 255, 255, 0.8);
}

.container .correct-box .top {
  background-color: #457f62;
  width: 100%;
  margin: 1rem 0;
  border-radius: 10px;
  color: white;
  font-size: 1.5rem;
  letter-spacing: 0.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 0.5rem;
}

.model-place {
  width: 100%;
  height: 250px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 15px;
  border: 2px solid #ddd;
  position: relative;
  margin: 1rem 0;
  overflow: hidden;
}

/* 手指圖標提示樣式 */
.finger-icon-hint {
  position: absolute;
  top: 60%;
  left: 45%;
  transform: translate(-50%, -50%);
  z-index: 10;
  pointer-events: none;
}

.finger-icon-hint img {
  width: 50vw;
  /* height: 80px; */
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
}

.model-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #666;
  font-size: 1.2rem;
  text-align: center;
}

.model-place canvas {
  border-radius: 15px;
}

/* 禁用選項樣式 */
.image-options.disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
  pointer-events: none;
}

.image-options.disabled .image-option-left {
  background: rgba(153, 153, 153, 0.9) !important;
}

.disabled-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  border-radius: 15px;
}

/* 錯誤 Lightbox 樣式 */
.error-lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.error-lightbox {
  background: white;
  border-radius: 20px;
  width: 85%;
  max-width: 400px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  animation: lightboxIn 0.3s ease-out;
}

.error-lightbox-header {
  background: #e74c3c;
  color: white;
  padding: 1.5rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
}

.error-lightbox-content {
  padding: 1.5rem;
  text-align: center;
}

.error-lightbox-content p {
  font-size: 1.2rem;
  line-height: 1.6;
  color: #333;
  margin: 0;
  letter-spacing: 2px;
}

.error-lightbox-content p.en {
  letter-spacing: 0px;
}

.error-lightbox-footer {
  padding: 0rem 1.5rem 1.5rem;
  text-align: center;
}

.confirm-btn {
  background: #3498db;
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 25px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
}

.confirm-btn:hover {
  background: #2980b9;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3);
}

.confirm-btn:active {
  transform: translateY(0);
}

@keyframes lightboxIn {
  from {
    opacity: 0;
    transform: scale(0.7) translateY(-50px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* 過渡動畫 */
.slide-fade-enter-active {
  transition: all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.slide-fade-leave-active {
  transition: all 0.4s cubic-bezier(0.55, 0.06, 0.68, 0.19);
}

.slide-fade-enter-from {
  transform: translateX(50px) scale(0.95);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(-50px) scale(0.95);
  opacity: 0;
}

/* 選項動畫 */
.option-bounce-enter-active {
  transition: all 0.4s ease;
}

.option-bounce-leave-active {
  transition: all 0.3s ease;
}

.option-bounce-enter-from {
  opacity: 0;
  transform: translateY(30px) scale(0.9);
}

.option-bounce-leave-to {
  opacity: 0;
  transform: translateY(-30px) scale(0.9);
}

.option-bounce-move {
  transition: transform 0.4s ease;
}

/* 選項 hover 效果 */
.option-hover {
  transition: all 0.3s ease;
  cursor: pointer;
}

.option-hover:hover .image-option-left {
  background: rgba(67, 106, 178, 1) !important;
  transform: scale(1.1);
  transition: all 0.3s ease;
}

/* 問題文字動畫 */
.question-text {
  animation: slideInDown 0.8s ease-out;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 成功頁面動畫 */
.success-header {
  animation: successBounce 0.8s ease-out;
}

.success-text {
  animation: fadeInUp 1s ease-out 0.3s both;
}

@keyframes successBounce {
  0% {
    opacity: 0;
    transform: scale(0.3) translateY(-50px);
  }

  50% {
    transform: scale(1.05);
  }

  70% {
    transform: scale(0.98);
  }

  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 勾選圖標動畫 */
.check-icon {
  animation: checkPulse 2s infinite;
}

@keyframes checkPulse {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }
}

/* 載入動畫 */
.model-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* fade 過渡 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-in-bg {
  opacity: 0;
  animation: fadeIn 0.5s forwards;
}

.bounce-animation {
  animation: bounce 2s infinite ease-in-out;
}

.fade-out {
  animation: fadeOut 0.5s forwards;
}




@keyframes bounce {

  0%,
  100% {
    transform: translate(-50%, 0px) rotate(0deg);
  }

  25% {
    transform: translate(-50%, -5px) rotate(2deg);
  }

  50% {
    transform: translate(-50%, 0px) rotate(0deg);
  }

  75% {
    transform: translate(-50%, -5px) rotate(-2deg);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes pulse-glow {

  0%,
  100% {
    box-shadow:
      0 0 20px rgba(255, 255, 255, 0.3),
      0 0 40px rgba(67, 106, 178, 0.2);
    transform: scale(1);
  }

  50% {
    box-shadow:
      0 0 40px rgba(255, 255, 255, 0.7),
      0 0 80px rgba(67, 106, 178, 0.5),
      0 0 120px rgba(67, 106, 178, 0.3);
    transform: scale(1.02);
  }
}

/* Tablet 響應式設計 (768px - 1024px) */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .container {
    width: 75%;
  }

  .container .title-image {
    width: 90%;
  }

  .container .title-box {
    font-size: 3rem;
    margin: 1.5rem 0;
    padding: 1rem;
    border-radius: 25px;
  }

  .container .title-box .icon-QA {
    width: 8%;
    margin: 1.2rem 0rem;
  }

  .container .content-box,
  .container .correct-box {
    height: 55svh;
    margin-top: 3svh;
    border-radius: 30px;
  }

  .container .content-box p,
  .container .correct-box p {
    font-size: 2rem;
    letter-spacing: 3px;
    line-height: 1.8;
  }

  .footer-text {
    font-size: 1.3rem;
  }

  .footer-text img {
    width: 1.3rem;
  }

  .container .content-box .image-options {
    margin: 1.5rem 0;
  }

  .container .content-box .image-options .image-option-left {
    font-size: 3rem;
    width: 4.5rem;
    height: 4.5rem;
  }

  .container .content-box .image-options .image-option-right {
    width: 68%;
    padding: 1.2rem;
  }

  .container .correct-box .top {
    font-size: 2.5rem;
    margin: 1.5rem 0;
    padding: 1rem;
  }

  .model-place {
    height: 350px;
    margin: 1.5rem 0;
    border-radius: 20px;
  }

  .model-loading {
    font-size: 2rem;
  }

  .loading-spinner {
    width: 50px;
    height: 50px;
    border-width: 5px;
  }

  .disabled-overlay {
    font-size: 3.5rem;
  }

  /* Lightbox 調整 */
  .error-lightbox {
    width: 80%;
    max-width: 500px;
  }

  .error-lightbox-content p {
    font-size: 2rem;
    line-height: 1.8;
  }

  .confirm-btn {
    font-size: 2rem;
    padding: 1rem 2.5rem;
    border-radius: 30px;
  }
}

/* Large Tablet 響應式設計 (1025px - 1366px) */
@media screen and (min-width: 1025px) and (max-width: 1366px) {
  .container {
    width: 65%;
  }

  .container .title-image {
    width: 85%;
  }

  .container .title-box {
    font-size: 3.2rem;
    margin: 2rem 0;
    padding: 1.2rem;
    border-radius: 30px;
  }

  .container .title-box .icon-QA {
    width: 7%;
    margin: 1.5rem 0rem;
  }

  .container .content-box,
  .container .correct-box {
    height: 60svh;
    margin-top: 4svh;
    border-radius: 35px;
  }

  .container .content-box p,
  .container .correct-box p {
    font-size: 3rem;
    letter-spacing: 3px;
    line-height: 1.8;
  }
  .footer-text {
    font-size: 1.5rem;
  }

  .footer-text img {
    width: 1.5rem;
  }
  .container .content-box .image-options {
    margin: 2rem 0;
  }

  .container .content-box .image-options .image-option-left {
    font-size: 4rem;
    width: 5.5rem;
    height: 5.5rem;
  }

  .container .content-box .image-options .image-option-right {
    width: 65%;
    padding: 1.5rem;
  }

  .container .correct-box .top {
    font-size: 3rem;
    margin: 2rem 0;
    padding: 1.2rem;
  }

  .model-place {
    height: 320px;
    margin: 2rem 0;
    border-radius: 25px;
  }

  .model-loading {
    font-size: 3rem;
  }

  .loading-spinner {
    width: 55px;
    height: 55px;
    border-width: 6px;
  }

  .disabled-overlay {
    font-size: 4rem;
  }

  /* Lightbox 調整 */
  .error-lightbox {
    width: 70%;
    max-width: 600px;
  }

  .error-lightbox-content p {
    font-size: 3rem;
    line-height: 2;
  }

  .confirm-btn {
    font-size: 3rem;
    padding: 1.2rem 3rem;
    border-radius: 35px;
  }
}

/* Landscape Tablet 響應式設計 */
@media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .container {
    width: 70%;
  }

  .container .title-image {
    width: 75%;
  }

  .container .title-box {
    font-size: 1.8rem;
    margin: 1rem 0;
    padding: 0.8rem;
  }

  .container .title-box .icon-QA {
    width: 6%;
    margin: 1rem 0rem;
  }

  .container .content-box,
  .container .correct-box {
    height: 65svh;
    margin-top: 2svh;
  }

  .container .content-box p,
  .container .correct-box p {
    font-size: 1.3rem;
    letter-spacing: 3px;
    line-height: 1.6;
  }

  .container .content-box .image-options {
    margin: 1rem 0;
  }

  .container .content-box .image-options .image-option-left {
    font-size: 1.8rem;
    width: 3rem;
    height: 3rem;
  }

  .container .content-box .image-options .image-option-right {
    width: 70%;
    padding: 0.8rem;
  }

  .container .correct-box .top {
    font-size: 1.6rem;
    margin: 1rem 0;
    padding: 0.8rem;
  }

  .model-place {
    height: 220px;
    margin: 1rem 0;
  }

  .model-loading {
    font-size: 1.2rem;
  }

  .loading-spinner {
    width: 40px;
    height: 40px;
    border-width: 4px;
  }

  .disabled-overlay {
    font-size: 3rem;
  }

  /* Lightbox 調整 */
  .error-lightbox {
    width: 75%;
    max-width: 450px;
  }

  .error-lightbox-content p {
    font-size: 1.3rem;
    line-height: 1.6;
  }

  .confirm-btn {
    font-size: 1.2rem;
    padding: 0.8rem 2rem;
  }
}

/* 小尺寸 Tablet 特殊調整 */
@media screen and (max-width: 767px) and (min-height: 1000px) {

  .container .content-box,
  .container .correct-box {
    height: 65svh;
  }

  .model-place {
    height: 280px;
  }
}

/* 極小屏幕調整 */
@media screen and (max-width: 480px) {
  .container {
    width: 90%;
  }

  .container .title-box {
    font-size: 1.4rem;
    letter-spacing: 0.1rem;
  }

  .container .title-box .icon-QA {
    width: 12%;
  }

  .container .content-box p,
  .container .correct-box p {
    font-size: 1.3rem;
    letter-spacing: 3px;
  }

  .container .content-box .image-options .image-option-left {
    font-size: 1.5rem;
    width: 2.5rem;
    height: 2.5rem;
  }

  .container .content-box .image-options .image-option-right {
    width: 75%;
    padding: 0.8rem;
  }

  .disabled-overlay {
    font-size: 2.5rem;
  }

  .model-place {
    height: 200px;
  }

  .container .correct-box .top {
    font-size: 1.3rem;
  }

  /* Lightbox 調整 */
  .error-lightbox {
    width: 95%;
  }

  .error-lightbox-content p {
    font-size: 1.3rem;
    letter-spacing: 1px;
  }

  .confirm-btn {
    font-size: 1rem;
    padding: 0.8rem 1.5rem;
  }
}
</style>
